const phonePattern = /((\(\d{3}\))|(^\d{3}))( |\-)?\d{3}( |\-)?\d{4}/;
const zipPattern = /\d{5}(-\d{4})?/;
const currencyPattern = /^([\s]+)?$|[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;

export const phoneConstraints = {
  format: {
    pattern: phonePattern,
    message:
      "^Phone Number must be a valid 10-digit phone number, e.g. 555-555-5555.",
  },
};

export const zipCodeConstraints = {
  format: {
    pattern: zipPattern,
    message: "^ZIP must be a valid 5-digit ZIP Code or 9-digit ZIP+4.",
  },
};

export const currencyConstraints = {
  format: {
    pattern: currencyPattern,
    message: "^Amount must be a valid currency amount, e.g. 20 or 9.99",
  },
};



// WEBPACK FOOTER //
// ./src/constraints.js